<div *ngIf="showChipList">
    <simple-chip-list [editButtonText]="'Edit Tags'" [optionsListId]="optionsListId" [selectedIds]="selectedIds" (isEditClicked)="onEdit()">
    </simple-chip-list>
</div>